import React, { useEffect, useState} from "react";
import {
  FiUser,
  FiMail,
  FiPhone,
  FiMapPin,
  FiShoppingBag,
  FiTruck,
  FiCreditCard,
} from "react-icons/fi";
import "./checkout.css";

// const API_BASE = "https://api.thetotetherapy.com";
const DELIVERY_FEE = 20;

// OFFER RULE:
// ONLY when same product quantity is EXACTLY 2 => +1 FREE (deliver 3)
// Any other qty => NO FREE
const applyOffer = (cartItems) => {
  return cartItems.map((item) => {
    const qty = Number(item.quantity || 0); // user selected (paid qty)
    const price = Number(item.price || 0);

    const freeQty = qty === 2 ? 1 : 0;
    const deliverQty = qty + freeQty;

    const lineTotal = qty * price; // payment only for selected qty

    return { ...item, freeQty, deliverQty, lineTotal };
  });
};

export default function Checkout() {
  const [cart, setCart] = useState([]);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    address: ""
  });
  const [popup, setPopup] = useState("");

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("cart")) || [];
    setCart(stored);
  }, []);

  // apply offer for summary + totals
  const discounted = applyOffer(cart);
  const subtotal = discounted.reduce((sum, item) => sum + item.lineTotal, 0);
  const delivery = discounted.length > 0 ? DELIVERY_FEE : 0;
  const total = subtotal + delivery;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // const placeOrder = async (e) => {
  //   e.preventDefault();

  //   try {
  //     setPopup("Redirecting to payment...");

  //     const res = await fetch(
  //       "https://api.thetotetherapy.com/api/create-checkout-session",
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           form,
  //           cart: discounted, // send offer details too
  //           subtotal,
  //           delivery,
  //           total
  //         })
  //       }
  //     );

  //     const data = await res.json();

  //     if (!res.ok || !data?.url) {
  //       setPopup(data?.error || "Failed to start payment ❌");
  //       return;
  //     }

  //     window.location.href = data.url; // Stripe checkout open
  //   } catch (err) {
  //     setPopup("Something went wrong ❌");
  //   }
  // };
const placeOrder = async (e) => {
  e.preventDefault();

  try {
    setPopup("Placing your order...");

    const res = await fetch(
      "https://api.thetotetherapy.com/api/orders",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          phone: form.phone,
          address: form.address,
          cart: discounted,
          subtotal,
          delivery,
          total,
        }),
      }
    );

    const data = await res.json();

    if (!res.ok) {
      setPopup(data.message || "Failed to place order ❌");
      return;
    }

    localStorage.removeItem("cart");

    setPopup("✅ Order placed successfully! Cash on Delivery available.");

    setTimeout(() => {
      window.location.href = "/";
    }, 3000);

  } catch (err) {
    setPopup("Something went wrong ❌");
  }
};
  return (
    <main className="checkoutPage">
      {popup && <div className="checkoutPopup">{popup}</div>}

      <div className="checkoutContainer">
        {/* LEFT - FORM */}
        <form className="checkoutForm" onSubmit={placeOrder}>
          <h2 className="checkoutHeading">
            <FiUser /> Customer Details
          </h2>

          <div className="inputGroup">
            <FiUser />
            <input
              name="name"
              placeholder="Full Name"
              required
              onChange={handleChange}
            />
          </div>

          <div className="inputGroup">
            <FiMail />
            <input
              name="email"
              placeholder="Email Address"
              type="email"
              required
              onChange={handleChange}
            />
          </div>

          <div className="inputGroup">
            <FiPhone />
            <input
              name="phone"
              placeholder="Phone Number"
              required
              onChange={handleChange}
            />
          </div>

          <div className="inputGroup">
            <FiMapPin />
            <textarea
              name="address"
              placeholder="Full Delivery Address"
              required
              onChange={handleChange}
            />
          </div>

          <button type="submit" className="placeOrderBtn">
            <FiTruck /> Order Now – Pay on Delivery
          </button>
<p className="secureInfo">
  🚚 Cash on Delivery Available Across UAE
</p>
          <p className="secureInfo">
            <FiCreditCard /> Secure checkout. Your data is protected.
          </p>
        </form>

        {/* RIGHT - SUMMARY */}
        <div className="checkoutSummary">
          <h2 className="checkoutHeading">
            <FiShoppingBag /> Order Summary
          </h2>

          {discounted.map((item) => (
            <div key={item.id} className="summaryItem">
              <span>
                {item.title} × {item.quantity}
                {item.freeQty === 1 && ` (+1 FREE = ${item.deliverQty} total)`}
              </span>
              <span>AED {item.lineTotal.toFixed(2)}</span>
            </div>
          ))}

          <div className="summaryRow">
            <span>Subtotal</span>
            <span>AED {subtotal.toFixed(2)}</span>
          </div>

          <div className="summaryRow">
            <span>
              <FiTruck /> Delivery
            </span>
            <span>AED {delivery.toFixed(2)}</span>
          </div>

          <div className="summaryRow total">
            <span>Total</span>
            <span>AED {total.toFixed(2)}</span>
          </div>
        </div>
      </div>
    </main>
  );
}